import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";

/** Multi-select of doors. Options are `{id, label}`. */
const DoorsFilter = ({
  doors,
  selected,
  onChange,
  allKey = "doorAccess.filters.allDoors",
  countKey = "doorAccess.filters.doorsCount",
}) => {
  const { t } = useTranslation("coaching-portal");
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    const close = (event) => {
      if (box.current && !box.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const toggle = (door) => {
    const isOn = selected.some((item) => item.id === door.id);
    onChange(
      isOn
        ? selected.filter((item) => item.id !== door.id)
        : [...selected, door]
    );
  };

  let label = t(allKey);
  if (selected.length === 1) label = selected[0].label;
  else if (selected.length > 1) {
    label = t(countKey, { count: selected.length });
  }

  return (
    <div className="door-dropdown" ref={box}>
      <button
        type="button"
        className="door-select"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        <span>{label}</span>
        <SvgIcon src="/img/new-icons/chevron-down.svg" useCurrentColor />
      </button>
      {open && (
        <div className="door-menu" role="listbox" aria-multiselectable="true">
          {doors.map((door) => {
            const on = selected.some((item) => item.id === door.id);
            return (
              <button
                key={door.id}
                type="button"
                role="option"
                aria-selected={on}
                onClick={() => toggle(door)}
              >
                <span className="door-check" data-on={on || undefined} />
                {door.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DoorsFilter;
